module.exports = __webpack_public_path__ + "static/media/collection-bird-10-effect.ad598bb3.png";